import { useEffect } from "react";
import { useWatch } from "react-hook-form";
import type { RoomType } from "@circle-react/helpers/liveStreamRoomHelpers";
import { ROOM_TYPES } from "@circle-react/helpers/liveStreamRoomHelpers";

export const useRoomType = (setRoomType?: (roomType: RoomType) => void) => {
  const roomType = useWatch<{ room_type: RoomType }>({
    name: "room_type",
    defaultValue: ROOM_TYPES.STREAM,
  });
  useEffect(() => {
    setRoomType?.(roomType);
  }, [roomType, setRoomType]);

  return roomType;
};
